










import { computed, defineComponent } from '@vue/composition-api'
export default defineComponent({
  props: {
    checked: {
      type: [Boolean, Array, String],
    },
    value: {
      type: [Boolean, Array, String],
      default: false,
    },
    disabled: {
      type: [Boolean, Array, String],
      default: false,
    },
  },
  setup(props, { emit }) {
    const checkboxValue = computed({
      get() {
        return props.value
      },
      set(val: boolean) {
        emit('input', val)
        emit('change', val)
      },
    })
    return {
      checkboxValue
    }
  },
})
